import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_MaxSubarray = () => (
  <DAAModuleSubtopic
    title="Divide and Conquer – Maximum Subarray Sum"
    videos={[
      "https://www.youtube.com/embed/OKCBidfgj3Q",
      "https://www.youtube.com/embed/u7YMFRUFqe0",
      "https://www.youtube.com/embed/upFa1-phDqc"
    ]}
    takeaways={[
      { text: "Divide the array into two halves." },
      { text: "Conquer by solving recursively for: maximum subarray sum in the left half, right half, and crossing the middle." },
      { text: "Combine by returning the maximum of the three values." },
      { text: "To find the crossing subarray: find max sum left from mid, max sum right from mid+1, then sum them." },
      { text: "Time Complexity: T(n) = 2T(n/2) + O(n) → O(n log n)." },
      { text: "Applications: Financial analysis (max profit intervals), Signal processing, Subsequence scoring in bioinformatics." },
      { image: "/MSA1.png",},
      { image: "/MSA2.png",}
    ]}
    questions={[
      {
        text: "Define the maximum sub-array sum problem. Find the series of contiguous elements that results in the maximum sub-array sum for the array [-2,-3,1,4,-1,3,5,-4,6,1]."
      },
      {
        text: "The subarray sum S(i,j) is the contiguous subarray with the largest sum. Consider a sequence of 8 elements: A = [-2, 3, 4, -1, -2, 1, 5, -3]. Design an O(n log n) algorithm to find the maximum sum subarray and determine the S(i,j) of A, where 1 ≤ i ≤ j ≤ 8."
      }
    ]}
    exampleVideos={[]}
  />
);

export default DAA_MaxSubarray ;
